import {Pipe, PipeTransform} from '@angular/core';
import {WidgetDto} from '../../Models/Widgets/widget.interface';

@Pipe({
  name: 'widgets',
  standalone: false
})
export class WidgetsPipe implements PipeTransform {

  transform(items: WidgetDto[], filter: { favorite: boolean }): WidgetDto[] {

    if (!items.length) {
      return [];
    }

    return items.filter((widget) => filter.favorite ? widget.favorite : !widget.favorite);

  }

}
